import { useState } from "react";

import Modal, { ModalProps } from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { ResumeGrouped } from "@/services/esus/attendanceService";
import { Cid } from "@/@types/esus/Cid";

import { AttendanceRateByCidTableFilters } from "../AttendanceRateByCidTableFilters";
import { AttendanceRateByCidTable } from "../AttendanceRateByCidTable";

type Props = ModalProps & {
	aggregatedAttendanceCids: ResumeGrouped<Cid, object>[];
};

export function AttendanceRateByCidModal({ aggregatedAttendanceCids, ...rest }: Props) {
	const [cidDescription, setCidDescription] = useState("");
	const aggregatedAttendanceCidsFiltered = aggregatedAttendanceCids.filter(
		(aggregatedAttendanceCid) =>
			aggregatedAttendanceCid.key.description
				.toUpperCase()
				.includes(cidDescription.toUpperCase()) ||
			aggregatedAttendanceCid.key.cidCode.toUpperCase().includes(cidDescription.toUpperCase())
	);

	return (
		<Modal {...rest} size="xl" aria-labelledby="contained-modal-title-vcenter" centered>
			<Modal.Header closeButton>
				<Modal.Title>Ranking de atendimentos por cid</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Row className="mb-8">
					<Col>
						<AttendanceRateByCidTableFilters
							cidDescription={cidDescription}
							setCidDescription={setCidDescription}
						/>
					</Col>
				</Row>
				<AttendanceRateByCidTable
					aggregatedAttendanceCids={aggregatedAttendanceCidsFiltered}
				/>
			</Modal.Body>
		</Modal>
	);
}
